
import {
    Component,
    Input,
    forwardRef,
    AfterViewInit,
    OnInit,
    EventEmitter,
    Output,
    ChangeDetectorRef
} from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NG_VALIDATORS } from '@angular/forms';
import { SysDictInfoSelectService } from './service/sys-dict-info-select.service';
@Component({
  selector: 'lc-dict-select',
  templateUrl: './lc-dict-select.component.html',
  styleUrls: ['./lc-dict-select.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => LcDictSelectComponent),
      multi: true,
    },
    SysDictInfoSelectService
  ],
})
export class LcDictSelectComponent implements ControlValueAccessor,AfterViewInit,OnInit {
  
  value:string;// 值
  items = [];// 数据源
  @Output() c8OnChange = new EventEmitter<any>();
  @Input('c8DictTypeCode')
  dictTypeCode = "";// 字典类型编码
    @Input('c8Parameter')
    parameter: string;
   private onChangeFn: (val: string) => void;
   optionList: any[] = []; // 过滤后的选项
   private onTouchedFn: () => void;
  constructor(private msg: NzMessageService,
              private service: SysDictInfoSelectService,
              private cd: ChangeDetectorRef,
  ) {}
  ngOnInit(): void {
      if (this.parameter) {
          const obj = JSON.parse(this.parameter);
          this.dictTypeCode=obj.dictTypeCode;
      }
  }
  ngAfterViewInit(): void {
   this.service.getListByDictType({dictTypeCode:this.dictTypeCode},{isCache:true}).then(res=>{
     this.items=res.data;
     this.optionList=this.items;
   })
  }
 
  getItemByType(value: string){
    const items= this.optionList.filter(f=>f.code === value);
    if(items.length>0){
      return items[0]
    } else{
      console.log(value+"字典项选项未找到");
    }
 }

  change(value: any): void {
    this.onChangeFn(value);
    this.c8OnChange.emit(this.getItemByType(value));
  }   

  writeValue(value: string): void {
    this.value = value+'';
    this.cd.detectChanges();
  }
  registerOnChange(fn: any): void {
    this.onChangeFn = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouchedFn = fn;
  }
}
